import { mapGetters } from 'vuex'
import MessageMixin from '@/mixins/message'
import { formatDisplayDateTime4 } from '@/utils/date'

export const debitNoteViewMixin = {
  data() {
    return {
      debitNoteForm: {
        actionName: null,
        branch: null,
        documentNo: null,
        transactionType: 'A',
        docAE: true,
        transactionDate: null,
        accountNo: null,
        fund: null,
        accountNoSuffix: null,
        gstIO: null,
        gstStatus: null,
        gstRate: (0.00).toFixed(2),
        amountCurr: null,
        amountCurrRate: (0.00).toFixed(2),
        gstAmountAE: true,
        amount: (0.00).toFixed(2),
        gstAmountCurr: null,
        gstAmount: (0.00).toFixed(2),
        netAmountCurr: null,
        netAmount: (0.00).toFixed(2),
        netLocalAmountCurr: null,
        netAmountLocalAE: true,
        netLocalAmount: (0.00).toFixed(2),
        printDocument: null,
        policyNo: null,
        companyName: null,
        docAddress1: null,
        docAddress2: null,
        docAddress3: null,
        docAddress4: null,
        postalCode: null,
        details: null,
        statementRef: null,
        department: null,
        insuredName: null,
        claimNo: null,
        gstRegNo: null,
        taxInvoiceNo: null,
        isExistDocNo: null,
        oldFund: null,
        oldAccountNoSuffix: null,
        oldAccountNo: null,
        insdRefNo: null,
        bmBrn: null,
        bmTranType: null,
        bmDocNo: null,
        bmFund: null,
        bmAcctNoSfx: null,
        bmAcctNo: null,
        cnNo: null,
        vehRegNo: null,
        bchMch: false,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      debitNoteFormLabel: {
        branch: 'Branch',
        documentNo: 'Document No.',
        transactionType: 'Transaction Type',
        docAE: 'Auto Debit Note No.',
        transactionDate: 'Transaction Date',
        accountNo: 'Account No.',
        fund: 'Fund',
        accountNoSuffix: 'Suffix',
        gstIO: 'GST IO',
        gstStatus: 'Status',
        gstRate: 'Rate',
        amountCurr: 'Amount Currency',
        amount: 'Amount',
        gstAmountCurr: 'GST Amount Currency',
        gstAmount: 'GST Amount',
        netAmountCurr: 'Net Amount Currency',
        netAmount: 'Net Amount',
        netLocalAmountCurr: 'Net Local Amount Currency',
        netLocalAmount: 'Net Local Amount',
        printDocument: 'Print Document',
        addressTo: 'Address To',
        policyNo: 'Policy',
        companyName: 'Name',
        docAddress1: 'Address 1',
        docAddress2: 'Address 2',
        docAddress3: 'Address 3',
        docAddress4: 'Address 4',
        postalCode: 'Postal Code',
        details: 'Details',
        statementRef: 'Statement Reference',
        department: 'Department',
        insuredName: 'Insured Name',
        claimNo: 'Claim No',
        gstRegNo: 'GST Reg No',
        taxInvoiceNo: 'Their Tax Invoice No',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      branches: [],
      gstIO: [
        { label: '', value: 'B' },
        { label: 'O - Output', value: 'O' },
        { label: 'I - Input', value: 'I' }
      ],
      printDocOpts: [
        { label: 'I - Immediately', value: 'I' },
        { label: 'L - Later', value: 'L' },
        { label: 'N - No', value: 'N' }
      ],
      addressToOpts: [
        { label: 'A - Agent', value: 'A' },
        { label: 'I - Insured', value: 'I' },
        { label: 'E - Entered as below', value: 'E' }
      ],
      nowDT: formatDisplayDateTime4(new Date()),
      createdName: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  mixins: [
    MessageMixin
  ]
}
